export default __webpack_public_path__ + "static/media/map-pin-gray.44e2b3b8.svg";